export const configUat = {
  clientId: "d35549fa-ae3b-44f1-b740-e99f7ad925bf",
  authority:
    "https://login.microsoftonline.com/2f0e80a6-80a9-4c92-8401-b2711c15efdc/v2.0",
  postLogoutRedirectUri: "https://uat.ams.aurora.io/",
  redirectUri: "https://uat.ams.aurora.io/",
  scopes: ["https://api.uat.ams.aurora.io/TENANT_giacom2"],
  apiUrl: "https://api.uat.ams.aurora.io/v1",
};
